<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table :infoTable="queriedData" :columns="tableColumns">
            <template slot="appendColumns">
              <el-table-column
                prop="status"
                min-width="120"
                :label="$t('common_words.status')"
                :align="'center'"
                :sortable="true"
                :fixed="true"
              >
                <template slot-scope="scope">
                  <el-tag :type="getStatusTagType(scope.row.status)">{{
                    scope.row.status
                  }}</el-tag>
                </template>
              </el-table-column>
            </template>
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                :canDisable="true"
                :canDelete="false"
                :minWidth="100"
                :extraValidateEdit="{
                  valueToValidate: 'cerrado',
                  targetToValidate: 'row.status',
                  operationToValidate: '!==',
                }"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: 'pqrs.pdf',
            route: 'pqrs/pqrs/pdf',
            paramMethod: 'POST',
            plusData: { exportType: 'admin' },
          }"
          :xls="{
            filename: 'pqrs.xlsx',
            route: 'pqrs/pqrs/excel',
            paramMethod: 'POST',
            plusData: { exportType: 'admin' },
          }"
        />
        <br />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="50%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <div class="card" v-if="rowData">
          <div class="card-body">
            <pqr-details-table :pqrData="rowData" />
          </div>
          <footer-date-at
            class="card-footer"
            :createdAt="rowData.created_at"
            :updatedAt="rowData.updated_at"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import configTable from './pqrTable';
import PqrTableDetails from '../PqrTableDetails.vue';

export default {
  components: {
    [PqrTableDetails.name]: PqrTableDetails,
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
    };
  },
  computed: { ...configTable().Search },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinExport,
    MixinMenu,
    MixinNotification,
  ],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(_, row) {
      this.rowData = {
        ...row,
        created_at: moment(
          String(row.created_at),
          'YYYY-MM-DD HH:mm:ss'
        ).format('YYYY-MM-DD hh:mm:ss'),
      };
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      this.rowData = { ...row };
      sessionStorage.setItem('editForm', JSON.stringify(this.rowData));
      this.$router.push({
        path: '/pqrs/manages/edit',
      });
    },

    getStatusTagType(status) {
      switch (status) {
        case 'abierto':
          return 'primary';
        case 'en proceso':
          return 'warning';
        case 'cerrado':
          return 'info';
        default:
          return '';
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('pqrs/pqrs')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('pqrs');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('pqrs');
  },
};
</script>
